export enum SiteFilter {
	ADULTS,
	KIDS,
	NONMEDICAL,
}

export type Department = {
	type: { key: string;}[];
	naamNL: string;
	naamFR: string;
	label: string;
	link: string;
	siteFilter: SiteFilter[];
};
